export default __webpack_public_path__ + "static/media/cross-menu-icon.315d6b41.svg";